import ImageUploadField from '../common/ImageUploadField';
import { appendFormValue, appendFiles } from '../../utils/formData';

export default function ComboForm({ form, onChange, products = [] }) {
  const set = (field, value) => onChange({ ...form, [field]: value });

  const setArrayField = (field, value) => {
    const arr = value.split(',').map((s) => s.trim()).filter(Boolean);
    set(field, arr);
  };

  const updateProductItem = (index, field, value) => {
    const items = [...(form.products || [])];
    items[index] = { ...items[index], [field]: value };
    set('products', items);
  };

  const addProductItem = () => {
    set('products', [...(form.products || []), { product: '', quantity: '1' }]);
  };

  const removeProductItem = (index) => {
    set('products', form.products.filter((_, i) => i !== index));
  };

  return (
    <div className="form-grid">
      <div className="form-group full">
        <label>Title *</label>
        <input className="input" value={form.title || ''} onChange={(e) => set('title', e.target.value)} required />
      </div>
      <div className="form-group">
        <label>Price (₹) *</label>
        <input
          type="number"
          className="input"
          min="0"
          value={form.price ?? ''}
          onChange={(e) => set('price', parseFloat(e.target.value) || 0)}
          required
        />
      </div>
      <div className="form-group">
        <label>Original Price (₹)</label>
        <input
          type="number"
          className="input"
          min="0"
          value={form.originalPrice ?? ''}
          onChange={(e) => set('originalPrice', parseFloat(e.target.value) || '')}
        />
      </div>
      <div className="form-group full">
        <label>Tagline</label>
        <input className="input" value={form.tagline || ''} onChange={(e) => set('tagline', e.target.value)} />
      </div>
      <div className="form-group full">
        <label>Description</label>
        <textarea className="input textarea" rows={3} value={form.description || ''} onChange={(e) => set('description', e.target.value)} />
      </div>

      <ImageUploadField
        label="Combo Image"
        existingUrls={form.existingImage ? [form.existingImage] : []}
        onExistingChange={(urls) => set('existingImage', urls[0] || '')}
        files={form.newImageFiles || []}
        onFilesChange={(files) => set('newImageFiles', files)}
      />

      <div className="form-group full">
        <label>Benefits (comma separated)</label>
        <input className="input" value={(form.benefits || []).join(', ')} onChange={(e) => setArrayField('benefits', e.target.value)} />
      </div>
      <div className="form-group checkbox-group">
        <label>
          <input type="checkbox" checked={!!form.includesConsultation} onChange={(e) => set('includesConsultation', e.target.checked)} />
          Includes Consultation
        </label>
      </div>
      <div className="form-group checkbox-group">
        <label>
          <input type="checkbox" checked={!!form.featured} onChange={(e) => set('featured', e.target.checked)} />
          Featured
        </label>
      </div>
      <div className="form-group full">
        <div className="form-section-header">
          <label>Products in Combo</label>
          <button type="button" className="btn btn-outline btn-sm" onClick={addProductItem}>
            + Add Product
          </button>
        </div>
        {(form.products || []).map((item, index) => (
          <div key={index} className="combo-product-row">
            <select
              className="input"
              value={item.product?._id || item.product || ''}
              onChange={(e) => updateProductItem(index, 'product', e.target.value)}
            >
              <option value="">Select product</option>
              {products.map((p) => (
                <option key={p._id} value={p._id}>{p.name}</option>
              ))}
            </select>
            <input
              className="input"
              placeholder="Qty"
              value={item.quantity || ''}
              onChange={(e) => updateProductItem(index, 'quantity', e.target.value)}
            />
            <button type="button" className="btn btn-ghost btn-sm" onClick={() => removeProductItem(index)}>×</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export const emptyComboForm = {
  title: '',
  price: '',
  originalPrice: '',
  tagline: '',
  description: '',
  existingImage: '',
  newImageFiles: [],
  benefits: [],
  includesConsultation: false,
  featured: false,
  products: [],
};

export function comboToForm(combo) {
  if (!combo) return { ...emptyComboForm };
  return {
    title: combo.title || '',
    price: combo.price ?? '',
    originalPrice: combo.originalPrice ?? '',
    tagline: combo.tagline || '',
    description: combo.description || '',
    existingImage: combo.image || '',
    newImageFiles: [],
    benefits: combo.benefits || [],
    includesConsultation: !!combo.includesConsultation,
    featured: !!combo.featured,
    products: (combo.products || []).map((p) => ({
      product: p.product?._id || p.product || '',
      quantity: p.quantity || '1',
    })),
  };
}

export function formToComboFormData(form) {
  const formData = new FormData();
  const products = (form.products || [])
    .filter((p) => p.product)
    .map((p) => ({ product: p.product, quantity: p.quantity || '1' }));

  appendFormValue(formData, 'title', form.title);
  appendFormValue(formData, 'price', form.price);
  appendFormValue(formData, 'originalPrice', form.originalPrice);
  appendFormValue(formData, 'tagline', form.tagline);
  appendFormValue(formData, 'description', form.description);
  appendFormValue(formData, 'benefits', form.benefits || []);
  appendFormValue(formData, 'includesConsultation', form.includesConsultation);
  appendFormValue(formData, 'featured', form.featured);
  if (products.length > 0) {
    appendFormValue(formData, 'products', products);
  }
  appendFormValue(formData, 'existingImage', form.existingImage || '');
  appendFiles(formData, 'image', form.newImageFiles || []);

  return formData;
}
